/* eslint-disable */
export default {
  data: () => ({}),
  methods: {
    //* Os 4 proximos métodos são utilizados para a compressão de imagens nos comentários e listagens das tarefas.
    imgCompress (tagImg) {
      return new Promise((resolve, reject) => {
        var img = new Image()
        img.src = tagImg.src
        img.onload = val => {
          var canvas = document.createElement('canvas')
          var width = img.width
          var height = img.height
          // verifica apenas o tamanho do Width, pois se ele for muito grande ultrapassa o relatório, e já verificando ele, também formata o height e ajustando o tamanho altera a qualidade da imagem, pois estara alterando o real tamanho ad imagem
          let maxDefaultSizeWidth = 1200
          if (img.width > maxDefaultSizeWidth) {
            let proportionalSize = this.proportionalResize(img.width, img.height, maxDefaultSizeWidth)
            width = proportionalSize.width
            height = proportionalSize.height
          }
          canvas.width = width
          canvas.height = height
          canvas.getContext('2d').drawImage(img, 0, 0, width, height)
          var compressedImg
          canvas.toBlob((blob) => {
            const arq = new File([blob], 'file', {
              type: 'image/jpeg',
              lastModified: Date.now()
            })
            console.log(arq)
            compressedImg = URL.createObjectURL(blob)
            resolve(compressedImg)
          }, 'image/jpeg', 0.7)
        }
      })
    },
    getBase64ImageFromURL(url) {
      return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");
    
        img.onload = () => {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
    
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
    
          var dataURL = canvas.toDataURL("image/png");
    
          resolve(dataURL);
        };
    
        img.onerror = error => {
          reject(error);
        };
    
        img.src = url;
      });
    },
    getDataBlob(url){
      console.log('ugetDataBlobrl', url)
      var res = fetch(url);
      var blob = res.blob();
      var uri = parseURI(blob);
      return uri;
    },
    parseURI(d){
      var reader = new FileReader();    /* https://developer.mozilla.org/en-US/docs/Web/API/FileReader */
      reader.readAsDataURL(d);          /* https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL */
      return new Promise((res,rej)=> {  /* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise */
        reader.onload = (e) => {        /* https://developer.mozilla.org/en-US/docs/Web/API/FileReader/onload */
          res(e.target.result)
        }
      })
    },
    // PEga o html e encontra as imagens e Comprime as imagens e formata elas para base 64 para mandar pro back
    imgsCompressAndBase64 (idText) {
      return new Promise((resolve, reject) => {
        var div = document.createElement('div')
        if (idText === null) return resolve('')
        div.innerHTML = idText.trim()
        // feito o load de um document com os itens do comentario
        let imgs = div.getElementsByTagName('img')
        // caso não haja imagens
        if (imgs.length === 0) {
          resolve(div.innerHTML)
        } else {
          // reqArray é um array com o resultado das requisições das imagens em blob, caso a requisição já tenha completado seu indicie recebe true
          let reqArray = new Array(imgs.length)
          reqArray.fill(false, 0, reqArray.length)
          // para cada imagem dentro do vetor de imagens
          for (let i = 0; i < imgs.length; i++) {
            // para cada imagem dentro do vetor de imagens
            // caso ela esteja em blob deve ser feito a requisção da imagem
            if (imgs[i].src.slice(0, 5) === 'blob:') {
              this.imgCompress(imgs[i]).then(res => {
                // Salva a imagem compactada
                imgs[i].src = res
                this.dataUrltoBase64(imgs[i]).then(res => {
                  // inclui true na posição do reqArray para controlar quando que deve retornar tudo para os componetes superiores
                  reqArray[i] = true
                  // Salva a imagem em base64
                  imgs[i].src = res
                  // verifica apenas o tamanho do Width ou height, pois se ele for muito grande ultrapassa o relatório, e já verificando ele, também formata o height, e altera o tamanho sem alterar a qualidade da imagem
                  let maxDefaultSize = 500
                  if (imgs[i].width > maxDefaultSize || imgs[i].height > maxDefaultSize) {
                    let proportionalSize = this.proportionalResize(imgs[i].width, imgs[i].height, maxDefaultSize)
                    imgs[i].style.width = `${proportionalSize.width}px`
                    imgs[i].style.height = `${proportionalSize.height}px`
                  }
                  // caso o array de requisições esteja todo com true é retornado o valor das imagens
                  if (!reqArray.some(val => { return val === false })) {
                    resolve(div.innerHTML)
                  }
                }, err => {
                  console.log(err)
                  this.$store.commit('snackbar/change_values', {
                    text: 'Erro ao salvar imagens!',
                    color: 'error',
                    dialog: true
                  })
                })
              }, err => {
                console.log(err)
                this.$store.commit('snackbar/change_values', {
                  text: 'Erro ao salvar imagens!',
                  color: 'error',
                  dialog: true
                })
              })
            } else {
              // caso já esteja em base64
              reqArray[i] = true
              // caso todas as requisições já tenham terminado
              if (!reqArray.some(val => { return val === false })) {
                resolve(div.innerHTML)
              }
            }
          }
        }
      })
    },
    dataUrltoBase64 (tagImg) {
      return new Promise((resolve, reject) => {
        // o request é feito em forma de xmr
        let request = new XMLHttpRequest()
        // requisição get
        request.open('GET', tagImg.src, true)
        request.responseType = 'blob'
        request.onreadystatechange = () => {
          // ifs para verificação do status da requisição
          if (request.readyState === 4) {
            if (((request.status === 200) || (request.status === 0)) && (request.response)) {
              // quando terminada a requisição o arquivo é lido e é retornado em forma de base64
              var reader = new FileReader()
              reader.readAsDataURL(request.response)
              reader.onload = e => {
                resolve(e.target.result)
              }
            }
          }
        }
        request.send(null)
      })
    },
    openImageDialog (img) {
      this.img = img
      this.imageDialog = true
    },
    proportionalResize (width, height, maxDefaultSizeWidth) {
      // pega o maior valor para fazer a proporção por ele
      let biggerValue = width > height ? width : height
      // Pega a proporção de ajuste do width para ajudar o width e o heigth
      let diff = maxDefaultSizeWidth / biggerValue
      return {
        width: Math.round(width * diff),
        height: Math.round(height * diff)
      }
    },
    addImageListener (item) {
      var itemsArray = Array.prototype.slice.call(item)
      itemsArray.forEach((item, index) => {
        const itemImage = item.getElementsByTagName('img')
        Array.prototype.slice.call(itemImage).forEach((image) => {
          image.addEventListener('click', (e) => {
            this.openImageDialog({ src: e.target.attributes[0].value, width: image.width })
          })
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/imageCompress.js